module.exports = __webpack_public_path__ + "img/1.32fb4b70.png";